import React from 'react';
import { DirectionalHint, TooltipHost, useTheme } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
import { ArrowUp20Regular as Icon } from '@fluentui/react-icons';
import { layout_wrapper_id } from 'common/components/Layout/Layout';
import { IAppTheme } from 'common/theme/AppTheme';
import { useLocalizedStrings } from 'i18n';

import { IButtonImplProps } from '../BaseButton.types';
import { PrimaryButton } from '../PrimaryButton';

import { getStyles, inlineBlockStyle, wrapperStyles } from './ScrollUpButton.styles';

const ScrollUpButton = (props: IButtonImplProps) => {
  const theme = useTheme() as IAppTheme;
  const { t } = useLocalizedStrings();

  const { ariaLabel, className, onClick, styles, ...otherProps } = props;
  const customStyles = getStyles(styles);

  const wrapper = document.getElementById(layout_wrapper_id);

  const tooltipId = useId();

  if (!wrapper) {
    return null;
  }

  return (
    <div style={wrapperStyles}>
      <TooltipHost
        content={ariaLabel ?? t('Button.ScrollUp')}
        calloutProps={{ gapSpace: 8 }}
        styles={inlineBlockStyle}
        directionalHint={DirectionalHint.leftCenter}
        id={tooltipId}
      >
        <PrimaryButton
          aria-labelledby={tooltipId}
          className={className}
          styles={customStyles}
          onClick={(e) => {
            wrapper.scrollTo({ top: 0, behavior: 'smooth' });
            onClick?.(e);
          }}
          {...otherProps}
        >
          {/* Note: use white100 for both themes */}
          <Icon primaryFill={theme.appColors?.white100} />
        </PrimaryButton>
      </TooltipHost>
    </div>
  );
};

export default ScrollUpButton;
